import {Directive, OnInit} from '@angular/core';
import {MatSort} from '@angular/material/sort';

@Directive({
  selector: '[matSort]:not([matSortStart])'
})
export class DefaultMatSortStartDirective implements OnInit {

  constructor(private matSort: MatSort) {
  }

  ngOnInit(): void {
    this.matSort.start = 'desc';
  }
}
